import { SignApi } from '../classes/SignApi'

export default function widgetAuth ({ next, nextMiddleware, store, to }) {
  let errorHandler = response => {
    if (response.status !== 401 && response.data.success === true) {
      store.dispatch('authorize', response.data.token)

      return nextMiddleware()
    }
    store.dispatch('flushAuthorize')

    return next(to.meta.widget?.failureRedirect || '/site/error');
  }

  return new SignApi(to.query.token).constructWidget()
    .then(errorHandler)
    .catch(error => errorHandler(error.response))
}
